import React from 'react';
import {StyleSheet} from 'react-native';

import {Button} from '../../../components/Button';
import {Input} from '../../../components/Form/Input';
import {InputContainer} from '../../../components/Form/InputContainer';
import {CloseIcon, SearchIcon} from '../../../icons';

interface Props {
  value: string;
  onChangeText: (query: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
}

export const SearchBar = ({value, onChangeText, onFocus, onBlur}: Props) => {
  const hasInput = value.length > 0;

  return (
    <InputContainer style={styles.container}>
      <Input {...{value, onChangeText, onFocus, onBlur}} placeholder="Search" />

      <Button
        variant="transparent"
        onPress={() => hasInput && onChangeText('')}
        style={styles.iconContainer}>
        {hasInput ? <CloseIcon /> : <SearchIcon />}
      </Button>
    </InputContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    margin: 20,
    width: 'auto',
  },
  iconContainer: {
    zIndex: 10,
    opacity: 0.3,
  },
});
